import ApprovalContents from '@/components/MobileApproval/ApprovalContents';
import useSWRInfinite from 'swr/infinite';
import { Approval } from '@/types/api';
import { getApprovalkey, MAX_LIST_SIZE } from '@/components/MobileApproval';
import { APPROVAL_SEARCH_URL } from '@/constant/approval';
import { approvalSearchListFetcher } from '@/hooks/apiHooks/approval';
import Loading from '@/components/MobileApproval/Body/Loading';
import { useAtom, useAtomValue } from 'jotai';
import { approvalState, MyInfoState } from '@/recoil/atom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import ApprovalSkeleton from '@/components/MobileApproval/ApprovalSkeleton';
import ErrorMessage from '@/components/MobileSales/ErrorMessage';
import CheckBox from '@/components/MobileApproval/CheckBox';
import { ContentLayout } from '@/components/MobileApproval/ApprovalContents/styles';

const MyReferrer = () => {
  const [selectedState, setSelectedState] = useAtom(approvalState);
  const { t } = useTranslation();
  const { passportId } = useAtomValue(MyInfoState);

  const [isRn, setIsRn] = useState(false);

  useEffect(() => {
    window?.isRNWebview && setIsRn(true);
  }, []);

  const { data, size, setSize, isLoading, error, mutate } = useSWRInfinite<
    Approval[]
  >(
    getApprovalkey(APPROVAL_SEARCH_URL, {
      listSize: MAX_LIST_SIZE,
      currentPage: 1,
      sortType: 'authoredAt',
      orderType: 'desc',
      referrerPassportIds: [passportId],
      statuses: ['P', 'H', 'C'],
      unreadPassportIds: selectedState.unRead ? [passportId] : [],
      isBookmark: false,
    }),
    approvalSearchListFetcher<Approval>,
    {
      refreshInterval: isRn ? 1000 : 0,
      shouldRetryOnError: false, // 에러 발생 시 재시도를 하지 않도록 설정
      revalidateOnFocus: false,
    },
  );

  const resultData = data?.reduce((prev, next) => prev.concat(next));

  const readMoreData = () => {
    setSize(size + 1);
  };
  const isReachingEnd = data && data[data.length - 1]?.length < MAX_LIST_SIZE;

  const onClick = () =>
    setSelectedState({
      ...selectedState,
      unRead: !selectedState.unRead,
    });

  const handleRefresh = () => mutate();

  return (
    <ContentLayout>
      <CheckBox
        checked={selectedState.unRead}
        onClick={onClick}
        title={t('안읽은 것만')}
      />

      {isLoading ? (
        <>
          {Array.from({ length: 10 }, (_, i) => (
            <ApprovalSkeleton key={`ApprovalSkeleton-${i}`} />
          ))}
        </>
      ) : error ? (
        <ErrorMessage
          errorMessage={error?.response?.data?.message}
          errorCode={error?.response?.data?.status}
          refresh={handleRefresh}
        />
      ) : (
        <ApprovalContents data={resultData} onRefresh={handleRefresh} />
      )}
      {data && !isLoading && !isReachingEnd && (
        <Loading readMoreData={readMoreData} />
      )}
    </ContentLayout>
  );
};
export default MyReferrer;
